import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { withRouter } from "react-router-dom";
import { Textfit } from 'react-textfit';
import { useEffect, useRef, useState } from 'react';

const HotList = (props) => {

  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     picks: [],
  //     boxText: '',
  //     formattedText: '',
  //     rendered: false
  //   }
  //   this.test = this.test.bind(this);
  // }

  const [ boxText, setBoxText ] = useState('');
  const [ formattedText, setFormattedText ] = useState('');
  const [ rendered, setRendered ] = useState(false);
  const [ picks, setPicks ] = useState([]);
  const [ cnvImage, setCnvImage ] = useState([]);
  const [ encodedSvg, setEncodedSvg ] = useState([]);

  const img = useRef();
  // const svgImg = useRef();
  const fitBox = useRef();
  const canvas = useRef();
  const bla = useRef();

  let { id } = props.match.params

  useEffect( () => {
    const ctx = canvas.current.getContext("2d")

    let exampleParagraph = ''
    let text = ''


    // const svgImg = document.querySelector('#test');
    img.current.onload = () => {
      ctx.drawImage(img.current, 0, 0)
      fetch('https://hot100.4zzz.org.au/api/hotlist/' + id).then(response => response.json())
      .then(json => {

        // var n = json.length
        // json.forEach ( (i, j) => {
        //   let fx = 24;
        //   if (n > 10) {
        //     fx = 10 / n * fx
        //   }
        //   ctx.font = '700 ' + fx + 'pt Roboto'
        //   ctx.textAlign = 'left'
        //   ctx.fillStyle = j % 2 ? "#ff429e" : '#ff6c00'
        //   ctx.strokeStyle = '#000';
        //   ctx.fillText( i.artist.toUpperCase() + ' - ' + i.title.toUpperCase() , 500, j * (fx * 2) + 380, 800)
        //   // ctx.strokeText( i.artist.toUpperCase() + ' - ' + i.title.toUpperCase() , 500, j * (fx * 2) + 380, 800)
        // })

        var n = json.length
        json.forEach ( (i, j) => {
          let fx = 24;
          if (n > 10) {
            fx = 10 / n * fx
          }
          text += i.artist.toUpperCase() + ' — ' + i.title.toUpperCase() + ' ';
          exampleParagraph += `<span style="color: ${j % 2 ? 'RGB(4, 167, 205)' : 'RGB(0, 180, 63)'};">${String(i.artist).toUpperCase() + ' — ' + String(i.title).toUpperCase()}</span> `
          // ctx.strokeText( i.artist.toUpperCase() + ' - ' + i.title.toUpperCase() , 500, j * (fx * 2) + 380, 800)
        })

        setFormattedText(exampleParagraph)
        setBoxText(text)
        setPicks(json)

      })
    }
  }, [])

  const test = (event) => {
    if (boxText !== '' && !rendered ){

      const ctx = canvas.current.getContext("2d")

      const fontSize = fitBox.current.state.fontSize;

      const svgImg = document.createElement('img');


      const words = boxText.split(" ").length;
      const svgCode = 
  `<svg width="550" height="650" xmlns="http://www.w3.org/2000/svg">
      <foreignObject x="0" y="0" width="550" height="650">
          <p style="font-size: ${fontSize}px; line-height: 110%; font-weight: 700; text-align: justify; text-justify: inter-character; text-transform: uppercase; font-family: Roboto, sans-serif" xmlns="http://www.w3.org/1999/xhtml">${formattedText}</p>
      </foreignObject>
  </svg>`;
      // Remove newlines and replace double quotes with single quotes
      const svgCodeEncoded = svgCode.replace(/\n/g, '').replace(/"/g, "'").replaceAll("&", "&amp;");

      svgImg.onload = () => {
        // Get the output canvas context
    
        // Draw the image to the canvas
        ctx.drawImage(svgImg, 225, 205);
        setCnvImage(canvas.current.toDataURL())
        setRendered(true);


    };
    
      // Dynamically create an image element
     svgImg.src = `data:image/svg+xml,${svgCodeEncoded}`;
      setEncodedSvg(svgCodeEncoded)

      // bla.current.append(svgImg)
    // console.log(svgImg)

    }
  }

    // let { picks } = this.state
    // let { id } = this.props.match.params
    return (
      <Paper>
        {/*(picks.map((i) => (
          <div><b>{i.artist}</b> - {i.title}</div>  )
        )*/}
        {/* <Typography variant="h6">THANKS FOR YOUR VOTE!</Typography> */}
        {boxText !== '' && <Textfit ref={fitBox} onReady={() => { test() }} className="box" style={{ color: 'transparent', width:'500px', height:'500px', lineHeight: '100%', textAlign: 'justify', textJustify: 'inter-character', textTransform: 'uppercase', fontFamily: 'Roboto, sans-serif', display: rendered ? 'none' : 'block'}}>
          {boxText}
        </Textfit> }
        <img id='test' />
        <canvas ref={canvas} width={1000} height={1000} style={{width: '100%', display: 'none'}} />
        <img alt="the reference" ref={img} src={ process.env.PUBLIC_URL + '/ivoted2025.png'} style={{visibility: 'hidden', display: 'none'}} />
        <img alt="my-votes" src={cnvImage} style={{width: '100%'}} />
        <div ref={bla}></div>
      </Paper>
    )
}

export default withRouter(HotList)
